<template lang="">
  <div>
    <v-icon @click="toggleSort">
      {{ sort === "asc" ? "mdi-sort-ascending" : "mdi-sort-descending" }}
    </v-icon>
  </div>
</template>
<script>
export default {
  name: "SortIcon",
  props: {
    sort: {
      type: String,
      required: true
    }
  },
  methods: {
    toggleSort() {
      this.$emit("toggleSort");
    }
  }
};
</script>
